import { Component, OnInit, Input, ChangeDetectionStrategy, Injector, OnChanges } from '@angular/core';
import { ContinentalIndividualAssociationStore } from '../../../../../common-page-components/stores/entities-store/continental-individual-association-store';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { mergeMap, tap } from 'rxjs/operators';
import MemberAssociationsStore from 'src/app/common-page-components/stores/entities-store/continental-associations-store';

@Component({
  selector: 'app-continental-federation-link',
  templateUrl: './continental-federation-link.component.html',
  styleUrls: ['./continental-federation-link.component.scss'],
})
export class ContinentalFederationLinkComponent implements OnInit, OnChanges {

  /**
   * An input for set the id of continent.
   *
   * @type {string}
   * @memberof ContinentalFederationLinkComponent
   */
  @Input()
  memberId: string;

  @Input()
  routerLink: Array<string>;

  /**
   * A method for set the number of members.
   *
   * @type {number}
   * @memberof ContinentalFederationLinkComponent
   */
  membersCount: number

  /**
   * The continental store for set the data
   *
   * @type {ContinentalIndividualAssociationStore}
   * @memberof ContinentalFederationLinkComponent
   */
  continentalValue: ContinentalIndividualAssociationStore;

  /**
   * The member store value for component.
   *
   * @type {MemberAssociationsStore}
   * @memberof ContinentalFederationLinkComponent
   */
  memberStoreValue : MemberAssociationsStore;
  constructor(private http: HttpClient, private injector: Injector, private router: Router) { }

  /**
   * {@inheritdoc}
   *
   * @memberof ContinentalFederationLinkComponent
   */
  ngOnInit() {
    this.continentalValue = new ContinentalIndividualAssociationStore(this.http, this.injector);
    this.memberStoreValue = new MemberAssociationsStore(this.http);
    this.continentalValue.getRequest({ Continent: this.memberId }, false).pipe(
      mergeMap(a => {
        return this.memberStoreValue.requestData({ Continent: this.memberId, RBP: 'ALL' }, false);
      }),
      tap(a => {
        this.membersCount = (a.items.length);
      })
    ).subscribe();
  }

  /**
   * The data that comes from the store.
   *
   * @readonly
   * @memberof ContinentalFederationLinkComponent
   */
  get data() {
    return this.continentalValue.data[0] ? this.continentalValue.data[0] : undefined;
  }

  /**
   * The on changes hook for allow change the data.
   *
   * @memberof ContinentalFederationLinkComponent
   */
  ngOnChanges() {
    if (this.continentalValue) {
      this.continentalValue.getRequest({ Continent: this.memberId }, false)
      .pipe(
        mergeMap(a => {
          return this.memberStoreValue.requestData({ Continent: this.memberId, RBP: 'ALL' }, false);
        }),
        tap(a => {
          this.membersCount = (a.items.length);
        })
      )
      .subscribe();
    }
  }

  /**
   * A helper to visit the federation page.
   *
   * @memberof ContinentalFederationLinkComponent
   */
  goToFederation() {
    return ['/member', this.data.CaCode, this.data.Continent.toLowerCase().replace(/ /g, '-')];
  }
}
